import { getData } from '../../../../utils/api'
import { useEffect, useState } from 'react';
import { Footers } from '../../../Footers'
import { CloseOutline, UnorderedListOutline } from 'antd-mobile-icons'
import xx from './baogao.png';
import html2canvas from "html2canvas";
import { Swiper, Popup } from 'antd-mobile'

import { SWIPER, PART_FOUR_ITEMS, MEDIAS, NAV_ITEMS } from '../../../HomePage/consts'

import './index.css'

export const Gaokao = ({ activePage, setActivePage }) => {

    const [isShowPopup, setIsShowPopup] = useState(false)
    const [imgData, setimgData] = useState('')


    useEffect(() => {
        if (window.location.search.split('?id=')[1]) {
            getYanzeng()
        }

    }, []);

    const [dataSource, setDataSource] = useState({});
    const getList = async () => {
        const res = await getData('/api/user/zhengshu', 'post')
        if (res.data.code == 1) {
            setDataSource(res.data.data[0]);
        }
    }
    const bank = async () => {
        window.history.go(-1);
    }

    const getYanzeng = async () => {
        console.log();
        const res = await getData('/api/cee/zhengshu', 'post', { certificate_number: decodeURIComponent(window.location.search.split('?id=')[1].split('&onlinecode=')[1]), id_number: decodeURIComponent(window.location.search.split('?id=')[1].split('&onlinecode=')[0]) })
        if (res.data.code == 1) {
            setDataSource(res.data.data[0]);
            setTimeout(() => {
                onDownload()
            }, 2000);
        }
    }

    const ChangeDecimalToPercentage = (num, total) => {
        let data = (100 / total * num).toFixed(0)
        if (data > 0) {
            return (100 / total * num).toFixed(0) + '%'
        } else {
            return ''
        }
    }
    const onDownload = async (title) => {
        await html2canvas(document.getElementById('img-box')).then((canvas) => {
            const link = document.createElement("a");
            link.href = canvas.toDataURL();
            setimgData(link.href)
            // link.setAttribute("download", title + ".png");
            // link.style.display = "none";
            // document.body.appendChild(link);
            // link.click();
        });

        // setDownloadUrl(url)
    }
    const navContent = () => {
        return (
            <div className='my-nav'>
                {NAV_ITEMS.map(item => {
                    return (<div className='nav-items'>
                        {item.map(e => {
                            return (
                                <div className="nav-items-item" key={e.key}>
                                    <a href={e.hrefUrl}>{e.text}</a>
                                </div>
                            )
                        })}
                    </div>)
                })}</div>
        )
    }


    return (
        <div className='bacscs' style={{ height: '100vh' }}>
            <div className="wap-nav-bar wap-nav-bar1">
                <div className="wap-nav-bar__left">
                    <div className="van-nav-bar__left"><i className="van-icon van-icon-arrow-left van-nav-bar__arrow" onClick={bank}>
                    </i></div>
                </div>
                <div className="wap-nav-bar__center">
                    高考信息
                </div>
                <div className="wap-nav-bar__right">

                </div>

            </div>
            <div className="res-wrap">
                <div className="card">

                    <h3 className="res-h3 titlexccsad" onClick={() => onDownload(true)} >中国高等学校招生入学考试成绩单
                    </h3>
                    <div className='img-body' id='img-box'>
                        <div className="img-box" >
                            <p className='top7 ' style={{ top: '188px' }}>{dataSource.username}</p>
                            <p className='bot2 ' style={{ top: '188px' }}>{dataSource.certificate_number}</p>
                            <p className='top7' style={{ top: '214px' }}>{dataSource.gender ? '男' : '女'}</p>
                            <p className='bot2' style={{ top: '213px' }}>{dataSource.updatetime}</p>
                            <p className='top7' style={{ top: '238px' }}>{dataSource.id_number}</p>
                            <p className='top7' style={{ top: '262px' }}>{dataSource.exam_year}</p>
                            <p className='top7' style={{ top: '307px' }}>{dataSource.exam_pattern}</p>
                            <p className='top7' style={{ top: '332px' }}>{dataSource.exam_type}</p>
                            <p className='top7' style={{ top: '356px' }}>{dataSource.exam_province}</p>
                            <p className='top7' style={{ top: '380px' }}>{dataSource.exam_subject}</p>

                            <p className='bot7' style={{ top: '427px' }}>{dataSource.sub_chinese}</p>
                            <p className='bot7' style={{ top: '450px' }}>{dataSource.sub_maths}</p>
                            <p className='bot7' style={{ top: '473px' }}>{dataSource.sub_english}</p>
                            <p className='bot7' style={{ top: '496px' }}>{dataSource.sub_comprehensive}</p>
                            <p className='bot7' style={{ top: '518px' }}>{dataSource.sub_total}</p>

                            <p className='bot72' style={{ top: '427px' }}>{dataSource.sub_chinese_max}</p>
                            <p className='bot72' style={{ top: '450px' }}>{dataSource.sub_maths_max}</p>
                            <p className='bot72' style={{ top: '473px' }}>{dataSource.sub_english_max}</p>
                            <p className='bot72' style={{ top: '496px' }}>{dataSource.sub_comprehensive_max}</p>
                            <p className='bot72' style={{ top: '518px' }}>{dataSource.sub_total_max}</p>

                            <p className='bot73' style={{ top: '427px' }}>{ChangeDecimalToPercentage(dataSource.sub_chinese, dataSource.sub_chinese_max)}</p>
                            <p className='bot73' style={{ top: '450px' }}>{ChangeDecimalToPercentage(dataSource.sub_maths, dataSource.sub_maths_max)}</p>
                            <p className='bot73' style={{ top: '473px' }}>{ChangeDecimalToPercentage(dataSource.sub_english, dataSource.sub_english_max)}</p>
                            <p className='bot73' style={{ top: '496px' }}>{ChangeDecimalToPercentage(dataSource.sub_comprehensive, dataSource.sub_comprehensive_max)}</p>
                            <p className='bot73' style={{ top: '518px' }}>{ChangeDecimalToPercentage(dataSource.sub_total, dataSource.sub_total_max)}</p>

                            <p className='bot7' style={{ top: '550px', left: '115px', textAlign: 'left' }}>
                                {dataSource.exam_year}年{dataSource.exam_province} {dataSource.exam_subject}类 录取批次线:
                                <br />
                                本科第一批:{dataSource.first_score};本科第二批:{dataSource.second_score}。
                            </p>
                        </div>
                    </div>
                    <img className='img_benzun' src={imgData} width="58" />
                    <p style={{ display: !imgData ? 'block' : 'none', color: '#ccc' }} >正在加载，请稍后</p>
                </div>
            </div>
            <div style={{ height: '70px' }}></div>
            <div className='fbox_xxx'>
                <Footers />
            </div>
            {/* 导航弹出层 */}
            {isShowPopup && (<Popup
                visible={isShowPopup}
                onMaskClick={() => {
                    setIsShowPopup(false)
                }}
                onClose={() => {
                    setIsShowPopup(false)
                }}
                position='top'
                bodyStyle={{ height: '' }}
            >
                <div className="my-close-bar">
                    <a href="/wap/">
                        <img src="https://t3.chei.com.cn/chsi/assets/gb/wap/images/logo.png" alt="学信网" className="my-logo" />
                    </a>
                    <CloseOutline onClick={() => setIsShowPopup(false)} />
                </div>
                {navContent()}
            </Popup>)}
        </div >
    )
}